// extracted by mini-css-extract-plugin
module.exports = {"editScreen":"Details_Edit_editScreen__FgiL4","DefaultInputForm":"Details_Edit_DefaultInputForm__2GnNc","ErrorInputForm":"Details_Edit_ErrorInputForm__2eorK"};